"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldsWithColumns = function (fields, groups) {
    if (fields.length <= 2) {
        // not enough fields
        return fields.map(function (field) { return Object.assign({}, field, { column: '' }); });
    }
    // collect all related(group) fields for each field
    var fieldsGroup = {};
    groups.forEach(function (group) {
        group.forEach(function (field) { return fieldsGroup[field] = group; });
    });
    var nextColumn = '';
    return fields.map(function (field, index) {
        var fieldGroup = fieldsGroup[field.name] || [];
        var nextField = fields[index + 1] || null;
        var column = nextColumn;
        if (nextColumn) {
            nextColumn = '';
        }
        else if (nextField && fieldGroup.indexOf(nextField.name) !== -1) {
            // next field exist and it from current field group, move current/next fields to left/right columns
            nextColumn = 'right';
            column = 'left';
        }
        return Object.assign({}, field, { column: column });
    });
};
//# sourceMappingURL=mandatoryFieldsUIUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/utils/mandatoryFieldsUIUtils.js
// module id = 224
// module chunks = 0 1